import { apiSalesWeb } from '@shared/config';

export interface ICreateRequestIdrOutput {
  requestId: string;
}

export function createRequestId() {
  return apiSalesWeb.post<ICreateRequestIdrOutput>('/request');
}
